import { decode } from '@finn-no/safe-props';

export type Dataset = {
    stylelink: string;
    endpoint: string;
};

export const getDataProps = () => {
    const tjtElement = document.getElementById('tjt-podlet-frontpage');
    const encodedProps = tjtElement?.dataset.props;

    if (!encodedProps) return { stylelink: "", endpoint: "" };

    const props: Dataset = decode(encodedProps);
    return props;
};
